"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.wrapRootElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("./components");
const wrapRootElement = ({
  element
}, pluginOptions) => {
  if (process.env.GATSBY_PREVIEW_INDICATOR_ENABLED === `true` && !(pluginOptions !== null && pluginOptions !== void 0 && pluginOptions.disablePreviewUI)) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, element, /*#__PURE__*/_react.default.createElement(_components.Indicator, null));
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, element);
  }
};
exports.wrapRootElement = wrapRootElement;